<template>
  <form>
    <br />
    <p class="subtitle has-text-weight-bold">
      {{ nazivKarte }}
    </p>
    <p class="subtitle">{{ cenaKarte }} дин</p>
    <div class="columns">
      <div class="column is-one-third">
        <b-field
          label="Регистарски број таблица"
          :type="$v.broj_tablica.$error ? 'is-danger' : ''"
          :message="$v.broj_tablica.$error ? 'Број таблица није исправан' : ''"
        >
          <b-input v-model="broj_tablica" placeholder="PNXXXYY"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field
          label="Датум од"
          :type="$v.datum_od.$error ? 'is-danger' : ''"
          :message="$v.datum_od.$error ? 'Датум од је обавезан' : ''"
        >
          <b-datepicker v-model="datum_od" @input="onDatumOdChanged">
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field
          label="Датум до"
          :type="$v.datum_od.$error ? 'is-danger' : ''"
          :message="$v.datum_do.$error ? 'Датум до је обавезан' : ''"
        >
          <b-datepicker v-model="datum_do" disabled> </b-datepicker>
        </b-field>
      </div>
    </div>
    <!-- <div class="columns">
      <div class="column is-8">
        <b-field
          label="Тип карте"
          :type="$v.tip_karte.$error ? 'is-danger' : ''"
          :message="$v.tip_karte.$error ? 'Тип карте је обавезан' : ''"
        >
          <b-select
            v-model="tip_karte"
            @input="onTipKarteChanged"
            placeholder="Изаберите врсту карте"
            expanded
            :disabled="cenovnik.length === 0"
          >
            <option value="">Изаберите врсту карте</option>
            <option
              v-for="stavka in cenovnik"
              :key="stavka.id"
              :value="stavka.id"
            >
              {{ stavka.naziv_karte }} - {{ stavka.cena }} дин</option
            >
          </b-select>
        </b-field>
      </div>
    </div> -->
    <!-- <div class="columns">
      <div class="column">
        <b-field label="Прималац">
          <div class="control is-clearfix">
            Јавно предузеће Дирекција за изградњу општине Параћин
          </div>
        </b-field>
      </div>
      <div class="column">
        <b-field
          label="Износ (дин)"
          :type="$v.iznos.$error ? 'is-danger' : ''"
          :message="$v.iznos.$error ? 'Износ је обавезан' : ''"
        >
          <b-input v-model="iznos"></b-input>
        </b-field>
      </div>
    </div> -->
    <div class="columns">
      <div class="column">
        <b-field
          label="Корисник паркинг места"
          :type="$v.uplatilac.$error ? 'is-danger' : ''"
          :message="
            $v.uplatilac.$error ? 'Корисник паркинг места је обавезан' : ''
          "
        >
          <b-input v-model="uplatilac" placeholder="Име и презиме"></b-input>
        </b-field>
      </div>
      <!-- <div class="column">
        <b-field label="Број рачуна">
          <div class="control is-clearfix">
            160-0000000462420-13
          </div>
        </b-field>
      </div> -->
    </div>
    <!-- <div class="columns">
      <div class="column is-6">
        <b-field label="Сврха уплате">
          <div class="control is-clearfix">
            {{ svrha_uplate }} {{ datumOdDo }}
          </div>
        </b-field>
      </div>
    </div> -->
    <b-button class="is-pulled-left" @click="onNazadClick">Назад</b-button>
    <b-button class="is-pulled-right" @click="onDodajUKorpuClick"
      >Додај у корпу</b-button
    >
  </form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import {
  required,
  minLength,
  maxLength,
  integer
} from 'vuelidate/lib/validators'

export default {
  props: ['idKarte', 'resetujPodatke'],
  data() {
    return {
      broj_tablica: '',
      //tip_karte: this.idKarte,
      primalac: 'DIRPN', // DIRPN
      iznos: 0,
      uplatilac: '',
      broj_racuna: '160-0000000462420-13', // 160-0000000462420-13
      svrha_uplate: '',
      //poziv_na_broj: '',
      datum_od: null,
      datum_do: null
    }
  },
  // created() {
  //   this.$store.dispatch('placanje/dajCenovnik')
  // },
  // mounted() {
  //   console.log('MesecnaPretplataForma mounted')
  // },
  // beforeUpdate() {
  //   this.datum_od = null
  //   this.datum_do = null
  // },
  // updated() {
  //   console.log('updated')
  //   // ovo se ispaljuje jad se pojavi ova komponenta
  //   // ovde resetujemo prethodno izavrana polja
  //   //this.broj_tablica = ''
  //   this.datum_od = null
  //   this.datum_do = null
  // },
  methods: {
    // dateFormatter(dt) {
    //   var dateoptions = { year: 'numeric', month: 'short', day: 'numeric' }
    //   return dt.toLocaleDateString('sr', dateoptions)
    // },
    // onTipKarteChanged(value) {
    //   //console.log(value)

    //   let stavka_cenovnika = this.dajStavkuCenovnikaPoId(value)
    //   console.log(stavka_cenovnika)

    //   this.datum_od = null
    //   this.datum_do = null

    //   //this.tip_karte = value
    //   this.iznos = stavka_cenovnika.cena
    //   this.svrha_uplate = stavka_cenovnika.naziv_karte
    // },
    onDatumOdChanged(value) {
      //this.datum_od = moment(value)
      let stavka_cenovnika = this.dajStavkuCenovnikaPoId(this.idKarte)
      let broj_meseci = stavka_cenovnika.broj_meseci
      this.datum_do = moment(value)
        .add(broj_meseci, 'M')
        .toDate()
    },
    onDodajUKorpuClick() {
      this.iznos = this.cenaKarte
      this.svrha_uplate = this.nazivKarte

      this.$v.$touch()

      if (this.$v.$invalid) {
        console.log(this.$v)
        return
      }

      const stavka = {
        broj_tablica: this.broj_tablica,
        tip_karte: this.idKarte,
        primalac: this.primalac,
        iznos: this.iznos,
        uplatilac: this.uplatilac,
        broj_racuna: this.broj_racuna,
        svrha_uplate: this.svrha_uplate + ' ' + this.datumOdDo,
        //poziv_na_broj: this.poziv_na_broj
        datum_od: this.datum_od.toISOString().split('T')[0],
        datum_do: this.datum_do.toISOString().split('T')[0]
      }

      this.$store.dispatch('placanje/dodajUKorpu', stavka)
      this.$emit('proizvodDodat')
    },
    onNazadClick() {
      this.$emit('nazad')
    }
  },
  computed: {
    nazivKarte() {
      let stavka = this.dajStavkuCenovnikaPoId(this.idKarte)
      //debugger
      return stavka ? stavka.naziv_karte : ''
    },
    cenaKarte() {
      let stavka = this.dajStavkuCenovnikaPoId(this.idKarte)
      return stavka ? stavka.cena : 0
    },
    datumOdDo() {
      if (this.datum_od && this.datum_do) {
        return (
          this.datum_od.toLocaleDateString('sr') +
          '-' +
          this.datum_do.toLocaleDateString('sr')
        )
      } else {
        return ''
      }
    },
    ...mapState('placanje', ['cenovnik']),
    ...mapGetters('placanje', ['dajStavkuCenovnikaPoId'])
  },
  watch: {
    resetujPodatke() {
      this.$v.$reset() // bez ovog prikazuje validacione greske
      this.datum_od = null
      this.datum_do = null

      window.scrollTo(0, 0)
    }
  },
  validations: {
    broj_tablica: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(8)
    },
    // tip_karte: {
    //   required
    // },
    iznos: {
      required,
      integer
    },
    uplatilac: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(100)
    },
    datum_od: {
      required
    },
    datum_do: {
      required
    }
  }
}
</script>

<style></style>
